<template>
    <div ref="accordionItem" class="accordion__item mb-6" :class="{ active: isOpen }">
		<div class="accordion__title" v-if="$slots.title || $slots.header">
			<slot name="header" :toggle="() => toggleItem(id)">
                <button
                    v-if="!accordionDisabled"

                    :id="'btn-' + id"
                    class="shadow-card p-6 w-full flex text-left disabled:cursor-not-allowed"
                    :class="{ active: isOpen, [headerClass]: true}"
                    :disabled="disabled || loading"
                    aria-expanded="false"
                    :aria-controls="'content-' + id"
                    type="button"
                    @click="() => toggleItem(id)"
                >
                    <slot name="title" :toggle="(force = true) => toggleItem(id, force)" />
                </button>

                <div
                    v-else

                    class="shadow-card p-6 w-full flex text-left"
                    :class="{ active: isOpen, [headerClass]: true}"
                >
                    <slot name="title" :toggle="(force = true) => toggleItem(id, force)" />
                </div>
            </slot>
		</div>

		<HeightTransition
            @opened="onOpened"
        >
			<div
				class="accordion__content !max-h-[unset] transition-all"
				:class="{ active: isOpen }"
				:id="'content-' + id"
				:aria-labelledby="'btn-' + id"
				:style="allowOverflow ? 'overflow: visible;' : ''"

				v-show="isOpen"
			>
				<div class="accordion__inner px-6 pt-8 pb-7" :class="{[background]: true, [bodyClass]: true}">
					<div class="card__content">
						<slot />

                        <slot name="footer" :toggle="toggleItem" :id="id" :loading="loading" />
					</div>
				</div>
			</div>
		</HeightTransition>
	</div>
</template>

<script setup>
    import { computed, inject, onBeforeMount, onUnmounted, ref, watch } from 'vue';
    import uniqueId from '../../../helpers/uniqueId';
    import HeightTransition from '../HeightTransition.vue';

    const props = defineProps({
        id            : String,
        bodyClass     : String,
        headerClass   : String,
        disabled      : Boolean,
        onOpen        : Function,
        onBeforeOpen  : Function,
        onClose       : Function,
        onBeforeClose : Function,
        onToggle      : Function,
        background    : {
            type    : String,
            default : 'bg-light'
        },
        allowOverflow : {
			type: Boolean,
			default: false
		}
    })

    const {toggleItem, isActive, idPrefix, setEvents, removeEvents, loading, disabled: accordionDisabled, multiOpen} = inject('accordion')

    const id = props.id ?? uniqueId(idPrefix)

    const isOpen = computed(() => isActive(id))

    const accordionItem = ref(null)

    const onOpened = () => {
        if(!multiOpen.value){
            accordionItem.value?.scrollIntoView({ behavior: 'smooth' })
        }
    }

    watch(
        [
            () => props.onOpen,
            () => props.onBeforeOpen,
            () => props.onClose,
            () => props.onBeforeClose,
            () => props.onToggle
        ], 
        () => setEvents(
            id,
            {
                onOpen        : props.onOpen,
                onBeforeOpen  : props.onBeforeOpen,
                onClose       : props.onClose,
                onBeforeClose : props.onBeforeClose,
                onToggle      : props.onToggle
            }
        ),
        {
            immediate: true
        }
    )

    onUnmounted(() => removeEvents(id))
</script>